// var windowHost = window.location.origin;
// const currentEnv = process.env.REACT_APP_VERCEL_ENV;
const BASEURL = process.env.REACT_APP_PUBLIC_URL;

//判断环境
// const isMain = currentEnv === "production" ? true : false;
// let pattern =
//   /^(http:\/\/localhost|http:\/\/192\.168|https:\/\/localhost|https:\/\/192\.168|file:\/\/*)/i;
// if (isMain) {
//   baseURL = `${BASEURL}`;
// } else if(pattern.test(windowHost)){
//   baseURL = `https://zblkobv16h.execute-api.us-east-1.amazonaws.com/`
// }

export const baseUrl = BASEURL;

// export let baseUrl = pattern.test(windowHost)
// ? `https://zblkobv16h.execute-api.us-east-1.amazonaws.com/`
// : `${baseURL}/`;
